import React from 'react';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import Icon from './components/Icon';
import style from './Spinner.module.css';

export default function Spinner() {
  return (
    <div className={style.container}>
      <div>
        <Icon icon={faCircleNotch} size="6x" spin className={style.spinner}/>
      </div>
    </div>
  );
}
